import { render, staticRenderFns } from "./addAutomaticTagsPopup.vue?vue&type=template&id=7027a2c4"
import script from "./addAutomaticTagsPopup.vue?vue&type=script&lang=js"
export * from "./addAutomaticTagsPopup.vue?vue&type=script&lang=js"
import style0 from "./addAutomaticTagsPopup.vue?vue&type=style&index=0&id=7027a2c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports